import { i18n } from '@/i18n';
import type { EmployeeResponse } from '@/types/employee';
import { notify } from '@/core/toast/notify';

export function resolveApprovalDelegateUserId(
  employee: EmployeeResponse | null | undefined,
  excludeUserId?: number,
): number | null {
  if (!employee) return null;
  if (!employee.userId) {
    notify.error(i18n.t('errors.selectedEmployeeNoUserAccount', { ns: 'workflow' }));
    return null;
  }
  if (excludeUserId != null && employee.userId === excludeUserId) {
    notify.error(i18n.t('errors.cannotDelegateToYourself', { ns: 'workflow' }));
    return null;
  }
  return employee.userId;
}
